import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { api, AuthError } from '../services/api/client';

const FIVE_MINUTES = 5 * 60 * 1000;
const THIRTY_MINUTES = 30 * 60 * 1000;

let isHandlingAuthError = false;

const getErrorMessage = (error: unknown): string | null => {
  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }

  return null;
};

const handleGlobalError = (error: unknown): void => {
  if (error instanceof AuthError) {
    if (isHandlingAuthError) {
      return;
    }

    isHandlingAuthError = true;
    api.removeToken();
    window.location.href = '/login';
    return;
  }

  const message = getErrorMessage(error);

  if (message) {
    toast.error(message);
  }
};

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: handleGlobalError,
  }),
  mutationCache: new MutationCache({
    onError: handleGlobalError,
  }),
  defaultOptions: {
    queries: {
      staleTime: FIVE_MINUTES,
      gcTime: THIRTY_MINUTES,
      refetchOnWindowFocus: true,
      refetchOnReconnect: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
